import { useEffect, useContext, useState, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import TaskController from '../../controllers/aia/TaskController';
import ValidateService from '../../services/ValidateService';

import SelectEnt from '../../components/selectComponents/SelectEnt';
import GbitTable from '../../components/tableComponents/GbitTable';

const Task = () => {
  useEffect(() => {
    document.title = '작업정보관리';
  }, []);

  const naviagte = useNavigate();
  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const tableRef = useRef(null);
  const [valueObj, setValueObj] = useState(null);
  const [searchParam, setSearchParam] = useState({
    entSn: store.entSn,
    pageSize: 10,
  });
  const [dataList, setDataList] = useState([]);
  const [deletedRows, setDeletedRows] = useState([]);

  const controller = useMemo(() => {
    return new TaskController(
      store,
      modalService,
      validateService,
      tableRef,
      naviagte,
      [searchParam, setSearchParam],
      {
        valueObj,
        setValueObj,
        dataList,
        setDataList,
        deletedRows,
        setDeletedRows,
      }
    );
  }, [store, modalService, validateService]);

  useEffect(() => {
    controller.init();
    controller.loadTaskOptions();
  }, []);

  useEffect(() => {
    if (tableRef.current) {
      tableRef.current.resetData(dataList);
    }
  }, [dataList]);

  const handleChange = async (field, value) => {
    const selectedTask = valueObj.taskOptions.find(
      option => option.taskId === value
    );
    setValueObj(prev => ({
      ...prev,
      [field]: value,
      comCdNm: selectedTask?.comCdNm || '',
      taskExpln: selectedTask?.taskExpln || '',
    }));
    await controller.valueObjChange(field, value);
    controller.loadWorkOptions(value);
  };

  const handleAddWorkRow = () => {
    const newRow = {
      rowNo: dataList.length,
      seq: dataList.length + 1,
      processName: '',
      processExpln: '',
      selected: false,
      weight: '',
      repeatedDmg: false,
      fingerDmg: false,
      repetition: '',
      totalCount: dataList.length + 1,
    };
    const updatedDataList = [...dataList, newRow];
    setDataList(updatedDataList);
    tableRef.current.resetData(updatedDataList);
  };

  // 작업 테이블 헤더 체크박스
  const tableHeaderClick = info => {
    let tableData = tableRef.current.getDataList();

    if (info.keyVal === 'selected') {
      for (let index = 0; index < tableData.length; index++) {
        tableData[index].selected = info.val;
      }

      tableRef.current.setDataList(tableData);
    }
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">작업정보관리</h2>
      </div>
      <ul className="guide-txt">
        <li>
          기업 내 공정을 선택하고 해당 공정의 단위작업에 대한 상세 내용을 입력해
          주세요
        </li>
        <li>
          2월 이내의 단기간 작업 또는 연간 총 작업일수가 60일을 초과하지 않는
          작업의 경우는 제외합니다.
        </li>
      </ul>
      <div className="tbl-wrap">
        <p className="tbl-msg">
          <em className="star-require">*</em> 표시는 필수 입력 사항입니다.
        </p>
        <table className="tbl data row">
          <tbody>
            {store.authrtId === 'ADMIN' && (
              <tr>
                <th scope="row">
                  기업<em className="star-require">*</em>
                </th>
                <td>
                  <div className="input-group">
                    <SelectEnt
                      model="entSn"
                      valueObj={searchParam}
                      valueChange={(model, value) => {
                        setSearchParam(prev => ({ ...prev, [model]: value }));
                      }}
                    />
                    <button
                      type="button"
                      className="btn md primary"
                      onClick={() => controller.loadTaskOptions()}
                    >
                      조회
                    </button>
                  </div>
                </td>
              </tr>
            )}
            <tr>
              <th scope="row">
                공정<em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <div className="input-group">
                    <label className="hidden-label" htmlFor="sel2" id="sel2Lbl">
                      라벨
                    </label>
                    <select
                      id="sel2"
                      className="form-select md"
                      value={valueObj?.taskId || ''}
                      onChange={e => handleChange('taskId', e.target.value)}
                      aria-labelledby="sel2Lbl"
                    >
                      <option value="">공정 선택</option>
                      {valueObj?.taskOptions?.map((option, index) => (
                        <option key={index} value={option.taskId}>
                          {option.comCdNm}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                공정 상세내용<em className="star-require">*</em>
              </th>
              <td>
                <p>{valueObj?.taskExpln}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="tbl-wrap">
        <h3 className="block-tit">
          단위작업 목록 <em className="star-require">*</em>
        </h3>
        <GbitTable
          ref={tableRef}
          id="taskInfo"
          tableName="taskTable"
          headerList={controller.headerList}
          bodyList={dataList}
          onHeaderClick={tableHeaderClick}
          onCellClick={() => {}}
          pageNow={searchParam?.currentPage}
          pageSize={searchParam?.pageSize}
          pageChange={value =>
            controller.searchParamChange('currentPage', value)
          }
        />
      </div>
      <div className="page-btn-wrap both">
        <div className="btn-wrap">
          <button
            type="button"
            className="btn xlg tertiary"
            onClick={handleAddWorkRow}
          >
            작업 추가
          </button>
          <button
            type="button"
            className="btn xlg tertiary"
            onClick={() => {
              controller.deleteWorkRows();
            }}
          >
            작업 삭제
          </button>
        </div>
        <button
          type="button"
          className="btn xlg primary"
          onClick={() => {
            controller.saveChanges();
          }}
        >
          저장하기
        </button>
      </div>
    </>
  );
};

export default Task;
